// import { parse } from "ipaddr.js";
// var Parse = require("parse");
import Parse from "@/main.js";
// function getUserRoles(user) {
//   var queries = [new Parse.Query("_Role").equalTo("users", user)];

//   for (var i = 0; i < 2; i++) {
//     queries.push(new Parse.Query("_Role").matchesQuery("roles", queries[i]));
//   }

//   return (user.rolesPromise = Parse.Query.or
//     .apply(Parse.Query, queries)
//     .find()
//     .then(function(roles) {
//       return roles;
//       return roles.map(function(role) {
//         return role.get("name");
//       });
//     }));
// }

export default {
  state: {
    user: null,
    user_roles: [],

    // consider deleting
    roles: [],
    rolesObj: {}
  },

  getters: {
    user(state) {
      return state.user;
    },
    getUserRolesFromState(state) {
      return state.user_roles;
    },

    getRoles(state) {
      return state.roles;
    },

    getRolesObj(state) {
      return state.rolesObj;
    }
  },

  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },

    setUserRolesToState(state, payload) {
      state.user_roles = payload;
    },

    setRoles(state, payload) {
      let obj = {};
      payload.forEach(item => (obj[item.get("name")] = item));
      state.rolesObj = obj;
      state.roles = payload;
    }
  },

  actions: {
    async fetchUserRoles({ commit, dispatch }, user) {
      var queries = [new Parse.Query("_Role").equalTo("users", user)];

      for (var i = 0; i < 2; i++) {
        queries.push(
          new Parse.Query("_Role").matchesQuery("roles", queries[i])
        );
      }

      return (user.rolesPromise = Parse.Query.or
        .apply(Parse.Query, queries)
        .find()
        .then(function(roles) {
          return roles;
          return roles.map(function(role) {
            return role.get("name");
          });
        }));
    },

    async setCurrentUser({ commit, dispatch }, user) {
      if (user != null) {
        // fetch deparment-based users' departments
        let q = new Parse.Query("User");
        q.include("departments");
        q.get(user.id);
        var refreshed_user = await q.first();
        dispatch("setUserDepartments", refreshed_user.get("departments"));
        commit("setUser", refreshed_user);

        // get and set loggedin user roles
        const roles = await dispatch("fetchUserRoles", user);
        commit("setUserRolesToState", roles);

        // fetch departments and categoies
        if (user.get("roles").includes("admin")) {
          await dispatch("fetchDepartments");
          await dispatch("fetchGlobalCategories");
        } else if (
          user.get("roles").includes("manager") ||
          user.get("roles").includes("surveys") ||
          user.get("roles").includes("articles") ||
          user.get("roles").includes("maps") ||
          user.get("roles").includes("files")
        ) {
          await dispatch("fetchDepartmentCategories");
          await dispatch("fetchGlobalCategories");
        }

        commit("setLoading", false);
        if (
          user.get("roles").includes("admin") ||
          user.get("roles").includes("manager") ||
          user.get("roles").includes("survey-editor") ||
          user.get("roles").includes("article-editor") ||
          user.get("roles").includes("file-editor") ||
          user.get("roles").includes("map-editor")
        ) {
          // await dispatch("fetchSidebarReports");
        }
      }
    },

    signUserIn({ commit, dispatch }, payload) {
      commit("setLoading", true);
      commit("clearError");

      Parse.User.logIn(payload.email, payload.password)
        .then(user => {
          if (user) {
            if (user.get("is_active") == false) {
              commit("setError", "User is deactive");
              dispatch("setCurrentUser", null);
              dispatch("logout", null);
            } else if (user.get("is_active") == true) {
              dispatch("setCurrentUser", user);
              commit("setLoading", false);
              location.reload();
            }
          }
        })
        .catch(error => {
          commit("setUser", null);
          commit("setLoading", false);
          commit("setError", error.message);
        });
    },

    async logout({ commit }, payload) {
      commit("setLoading", true);
      await Parse.User.logOut();
      commit("setUser", null);
      commit("setLoading", false);
      return true;
    },

    async fetchRoles({ commit }) {
      let q = new Parse.Query("_Role");
      let roles = await q.find();
      commit("setRoles", roles);
    }
  }
};
